import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=a3f4b95a&scoped=true&"
import script from "./step1.vue?vue&type=script&lang=ts&"
export * from "./step1.vue?vue&type=script&lang=ts&"
import style0 from "./step1.vue?vue&type=style&index=0&id=a3f4b95a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f4b95a",
  null
  
)

export default component.exports